import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import {
  Home,
  Login,
  Navbar,
  Footer,
  Dashboard,
  DashboardUsers,
  DashboardCategories,
  DashboardTests,
  DashboardTestResults,
  DashboardGeneratePinfl,
} from "./components";
import { useDispatch, useSelector } from "react-redux";
import { Snackbar, Alert, Box, CircularProgress } from "@mui/material";
import { snackbarDone } from "./store/SnackbarSlice";
import { getUserInfo } from "./store/userSlice";
import { switchLang } from "./store/languageSlice";
import { routes } from "./constant";
function App() {
  const dispatch = useDispatch();
  const { status, text, severity } = useSelector((state) => state.snackBar);
  const { isLoading } = useSelector((state) => state.loader);
  const { navData } = useSelector((state) => state.language);
  const { initializing } = useSelector((state) => state.user);

  // Restore theme
  useEffect(() => {
    if (localStorage.getItem("theme") === "dark") {
      localStorage.setItem("theme", "dark");
    } else {
      localStorage.setItem("theme", "light");
    }
    if (
      localStorage.theme === "dark" ||
      (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, []);

  // Restore language
  useEffect(() => {
    const lang = localStorage.getItem("lang");
    if (lang === "uz") dispatch(switchLang(navData[1]));
    else if (lang === "ru") dispatch(switchLang(navData[2]));
    else if (lang === "en") dispatch(switchLang(navData[0]));
  }, []);

  // Fetch user info on startup — token is already in Redux from localStorage
  useEffect(() => {
    dispatch(getUserInfo());
  }, []);
  // While checking auth on startup, show a spinner so protected routes
  // don't redirect to login before user info arrives
  if (initializing) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100vw",
          height: "100vh",
          background: "#0c0e30",
        }}
      >
        <CircularProgress style={{ color: "white" }} />
      </div>
    );
  }

  return (
    <>
      <div className="App dark:bg-black w-full h-screen">
        <Navbar />
        <Routes>
          <Route path={routes.HOME} element={<Home />} />
          <Route path={routes.LOGIN} element={<Login />} />
          {/* Dashboard */}
          <Route path={routes.DASHBOARD.HOME} element={<Dashboard />} />
          <Route path={routes.DASHBOARD.USERS} element={<DashboardUsers />} />
          <Route
            path={routes.DASHBOARD.TEST_RESULTS}
            element={<DashboardTestResults />}
          />
          <Route
            path={routes.DASHBOARD.GENERATE_PINFL}
            element={<DashboardGeneratePinfl />}
          />
          <Route
            path={routes.DASHBOARD.CATEGORIES}
            element={<DashboardCategories />}
          />
          <Route path={routes.DASHBOARD.TESTS} element={<DashboardTests />} />
        </Routes>
        <Footer />
      </div>
      <div>
        <Snackbar
          open={status}
          autoHideDuration={5000}
          onClose={() => dispatch(snackbarDone())}
        >
          <Alert
            onClose={() => dispatch(snackbarDone())}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {text}
          </Alert>
        </Snackbar>
        {isLoading && (
          <div
            className="loader"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: "0px",
              left: "0px",
              width: "100vw",
              height: "100vh",
              background: "rgba(12,14,48, 0.7)",
              zIndex: "20",
            }}
          >
            <Box sx={{ display: "flex" }}>
              <CircularProgress style={{ color: "white" }} />
            </Box>
          </div>
        )}
      </div>
    </>
  );
}

export default App;
